import Vue from 'vue';
import Vuex from 'vuex';
import VuexI18n from 'vuex-i18n'; // load vuex i18n module

import app from './modules/app';
import menu from './modules/menu';

import * as getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: false, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    menu,
  },
  state: {},
  mutations: {},
});

Vue.use(VuexI18n.plugin, store);
Vue.filter('translateIn', function (key, locale) {
  arguments[0] = locale;
  arguments[1] = key;
  return Vue.i18n.translateIn(...arguments);
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js